import * as React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import ZendeskFileUpload, {
  AttachmentTokens,
  ZendeskFileUploadStatus,
} from './ZendeskFileUpload';

export type MessageBody = {
  subject: string | null;
  description: string;
  link?: string | null;
  attachmentTokens: AttachmentTokens;
};

export type MessageFormStatus = {
  message: MessageBody;
  uploadInProgress: boolean;
};

type Props = {
  message: MessageBody;
  onChange: (arg0: MessageFormStatus) => any;
};

type State = {
  uploadInProgress: boolean;
};

export default class MessageForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      uploadInProgress: false,
    };
  }

  onAttachmentChange = (status: ZendeskFileUploadStatus) => {
    const { message, onChange } = this.props;
    const { uploadInProgress, tokens } = status;
    this.setState({ uploadInProgress });
    onChange({
      message: {
        ...message,
        attachmentTokens: tokens,
      },
      uploadInProgress,
    });
  };

  inputChanged = (event: React.SyntheticEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    const { message, onChange } = this.props;
    onChange({
      message: {
        ...message,
        [name]: value,
      },
      uploadInProgress: this.state.uploadInProgress,
    });
  };

  render() {
    const { description, link, subject } = this.props.message;
    let widgets = [
      <FormGroup key="msg">
        <Label for="exampleText">Message</Label>
        <Input
          className="mt-2"
          name="description"
          type="textarea"
          rows={10}
          placeholder="Type your message here..."
          value={description}
          onChange={this.inputChanged}
        />
      </FormGroup>,
      <ZendeskFileUpload key="file" onChange={this.onAttachmentChange} />,
    ];
    if (link) {
      widgets.unshift(
        <FormGroup key="link" className="my-4">
          <Label>
            Link
            <Input name="link" value={link} disabled={true} />
          </Label>
        </FormGroup>,
      );
    }
    if (subject || subject === '') {
      widgets.unshift(
        <FormGroup key="sub" className="my-4">
          <Label>
            Subject
            <Input
              name="subject"
              placeholder="Type a brief subject line..."
              value={subject}
              onChange={this.inputChanged}
              className="mt-2"
            />
          </Label>
        </FormGroup>,
      );
    }
    return <React.Fragment>{widgets}</React.Fragment>;
  }
}
